import React, { useState } from 'react';
import { User } from 'lucide-react';
import { speakerImageUrl } from '../utils/mediaUrls';

const SpeakerImage = ({
  speaker,
  alt = '',
  className = '',
  fallbackClassName = '',
  iconClassName = 'w-6 h-6 text-white'
}) => {
  const [failed, setFailed] = useState(false);
  const src = speakerImageUrl(speaker);

  if (!src || failed) {
    return (
      <div
        className={`speaker-image-fallback bg-gita-saffron flex items-center justify-center shrink-0 ${fallbackClassName || className}`}
        aria-hidden={!alt}
      >
        <User className={iconClassName} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || speaker}
      className={`speaker-image object-cover object-top shrink-0 ${className}`}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

export default SpeakerImage;
